/**
 * @file TileAspectField.tsx
 * @description «Высота плитки» у «Плиток» и «Категорий» пропорцией
 * (phase19.16; SB24; SB120 этап 3а — uiux-sb120-stage3 §3 «Плитки и
 * категории», данные db-design-sb120-stage3 §2 `tiles.aspect` /
 * `categories.aspect`): ширина ÷ высота 0,5–2, подсказки [1,5 низкая]
 * [1 обычная][0,75 высокая] (прежние ступени low / normal / high), «↺ 1».
 * Пропорция держит одинаковый вид на 360 и на 1280: при 6 в ряд плитки не
 * вытягиваются. Одно поле на обе панели; ползунок — живой предпросмотр.
 */

import { SECTION_LOOK_LIMITS } from "@chaiberi/shared";

import { NumberSliderField } from "../../../site-fields/NumberSliderField";
import { useSectionForm } from "../section-form-context";
import { ownValue } from "../../../../lib/site-fields/number-input";

const A = SECTION_LOOK_LIMITS.tileAspect;

export const TILE_ASPECT_HINT = "Ширина ÷ высота: больше 1 — ниже, меньше 1 — выше. При 6 в ряд плитки не вытягиваются.";

const PRESETS = [
  { label: "1,5 низкая", value: 1.5 },
  { label: "1 обычная", value: 1 },
  { label: "0,75 высокая", value: 0.75 },
] as const;

interface Props {
  value: number;
  onChange: (aspect: number) => void;
  /** Путь элемента — живой предпросмотр `…aspect`. */
  path: string;
}

export function TileAspectField({ value, onChange, path }: Props) {
  const { preview } = useSectionForm();
  return (
    <NumberSliderField
      label="Высота плитки"
      value={ownValue(value, A.default)}
      inherit={{ value: A.default, label: "обычная · 1" }}
      min={A.min}
      max={A.max}
      step={0.05}
      largeStep={0.25}
      unit="×"
      display={{ factor: 1, decimals: 2 }}
      presets={PRESETS}
      hint={TILE_ASPECT_HINT}
      onChange={(v) => onChange(v ?? A.default)}
      onPreview={(v) => preview(`${path}.aspect`, v ?? A.default)}
    />
  );
}
